<template>
    <div style="padding: 15px;height: 100vh">
        <div class="app-content">
            <a-card :title="topic[render_type].title">
                <template v-if="!business" #extra>
                    <a-space>
                        <div v-if="editable"> 
                            <a-button v-if="topic[render_type].button_title" style="display: flex"
                                type="primary" size="large" @click="button_on(render_type)">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                {{ topic[render_type].button_title }}
                            </a-button>
                        </div>

                        <a-dropdown v-if="topic[render_type].allow_import">
                            <template #overlay>
                                <a-menu >
                                    <a-menu-item key="1">
                                        <span class="material-symbols-outlined">description</span>
                                        import
                                    </a-menu-item>
                                    <a-menu-item key="2">
                                        <span class="material-symbols-outlined">description</span>
                                        Export
                                    </a-menu-item>
                                </a-menu>
                            </template>
                            <a-button style="display: flex;">
                                <span class="material-symbols-outlined">Settings</span>
                                ตัวเลือก
                                <span class="material-symbols-outlined">expand_more</span>
                            </a-button>
                        </a-dropdown>
                        <a-button v-if="logistics_a && render_type === 'PartHistory'" ref="import_file" @click="export_file()">
                            <span class="material-symbols-outlined">download</span>Export
                        </a-button>
                    </a-space>
                </template>

                <a-row v-if="business" style="display: flex; justify-content: flex-end;">
                    <a-space>
                        <div v-if="editable"> 
                            <a-button v-if="topic[render_type].button_title" style="display: flex"
                                type="primary" size="large" @click="button_on(render_type)">
                                <template #icon><span class="material-symbols-outlined">Add</span></template>
                                {{ topic[render_type].button_title }}
                            </a-button>
                        </div>
                        <a-dropdown v-if="topic[render_type].allow_import">
                            <template #overlay>
                                <a-menu >
                                    <a-menu-item key="1">
                                        <span class="material-symbols-outlined">description</span>
                                        import
                                    </a-menu-item>
                                    <a-menu-item key="2">
                                        <span class="material-symbols-outlined">description</span>
                                        Export
                                    </a-menu-item>
                                </a-menu>
                            </template>
                            <a-button style="display: flex;">
                                <span class="material-symbols-outlined">Settings</span>
                                ตัวเลือก
                                <span class="material-symbols-outlined">expand_more</span>
                            </a-button>
                        </a-dropdown>
                    </a-space>
                </a-row>
                <br v-if="topic[render_type].button_title && business">
                <a-row>
                    <a-space>
                        <a-space v-if="render_type === 'PartHistory' && logistics_a">
                            <a-input-search v-if="topic[render_type].input" v-model:value="search_input"
                            :placeholder="`ค้นหา ${topic[render_type].input}`" enter-button="ค้นหา" />
                            <a-select v-if="topic[render_type].select_stock" style="width: 100%" v-model:value="selected_type" placeholder="เลือกประเภทการเบิก">
                            <a-select-option v-for="{ text, value }, i in [
                                { text: 'เบิกเข้า', value: 1 },
                                { text: 'เบิกออก', value: 2 },
                            ]" :key="i" :value="value">{{ text }}
                            </a-select-option>
                        </a-select>
                        <a-range-picker v-if="topic[render_type].datepicker" v-model:value="datetime" />
                        </a-space>
                        <a-space v-else>
                        <a-input-search v-if="topic[render_type].input" v-model:value="search_input"
                            :placeholder="`ค้นหา ${topic[render_type].input}`" enter-button="ค้นหา"/>
                        <a-range-picker v-if="topic[render_type].datepicker" v-model:value="datetime" />
                        <!-- <a-select v-if="topic[render_type].select_stock" style="width: 100%" v-model:value="selected_type" placeholder="เลือกประเภทการเบิก">
                            <a-select-option v-for="{ text, value }, i in [
                                { text: 'เบิกเข้า', value: 1 },
                                { text: 'เบิกออก', value: 2 },
                            ]" :key="i" :value="value">{{ text }}
                            </a-select-option>
                        </a-select> -->
                        </a-space>
                        <a-select v-if="topic[render_type].select_status" style="width: 100%" v-model:value="selected_expire_type" placeholder="เลือกประเภทวันหมดอายุ">
                            <a-select-option v-for="{ text, value }, i in [
                                { text: 'ใหม่', value: 1 },
                                { text: 'ยืนยัน', value: 2 },
                                { text: 'ยืนยันตัดสต็อกจริง', value: 3 },
                                { text: 'ยกเลิก', value: 4 },
                            ]" :key="i" :value="value">{{ text }}
                            </a-select-option>
                        </a-select>
                        <a-button v-if="topic[render_type].clear" type="dashed" @click="clear_search">CLEAR</a-button>
                    </a-space>

                </a-row>

                <a-row>
                    <a-space>
                        <a-button v-for="button, i in topic[render_type].lower_buttons" :key="i" style="display: flex"
                            type="primary" size="large" @click="button_action(button.name)">
                            {{ button.title }}
                        </a-button>
                    </a-space>

                </a-row>
                <br>
                <a-row>
                    <a-table :columns="render_type === 'PartHistory' ? topic.PartHistoryLogisticsA.columns.filter((c) => !editable? c.key != 'id': true) :topic[render_type].columns.filter((c) => !editable? c.key != 'id': true)" :data-source="filtered_list(show_table_list)" bordered size="small" :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'withdraw_type'">
                                <span><a-tag :color="record.withdraw_type?.color|| 'default'">
                                    {{record.withdraw_type?.name || '-'}}
                                </a-tag></span>
                            </template>
                            <template v-if="column.key === 'withdraw_status'">
                                <span><a-tag :color="getColorWithDrawStatus(record) || 'default'">
                                    {{record.withdraw_status?.name || '-' }}
                                </a-tag></span>
                            </template>
                            <template v-if="column.key === 'withdrawed_at'">
                               {{ render_date(record.withdrawed_at) }}
                            </template>
                            <template v-if="column.key === 'stock_withdrawed_at'">
                                {{render_date(record.stock_history?.withdrawed_at) || '-' }}
                            </template>
                            <template v-if="column.key === 'fullname'">
                                {{ record.firstname && record.lastname ? `${record.firstname} ${record.lastname}` : '-' }}
                            </template>
                            <template v-if="column.key === 'part_barcode'">
                                        {{ record.part_histories?.[0]?.part?.barcode || '-' }}

                            </template>
                            <template v-if="column.key === 'part_name'">
                                        {{record.part?.name || '-' }}
                            </template>
                            <template v-if="column.key === 'stock_remark'">
                                        {{record.stock_history?.remark || '-' }}
                            </template>
                            <template v-if="column.key === 'stock_refno'">
                                        {{record.stock_history?.refno || '-' }}
                            </template>
                            <template v-if="column.key === 'part_type'">
                                        {{record.part_type?.name || '-' }}
                            </template>
                            <template v-if="column.key === 'part_unit'">
                                        {{record.part_unit?.name || '-' }}
                            </template>
                            <template v-if="column.key === 'part_unit_list'">
                                <div v-for="(name, index) in getUniquePartUnitNames(record)" :key="index">
                                    {{ name }}
                                </div>
                            </template>
                            <template v-if="column.key === 'part_list'">
                                <div v-for="(item, index) in record.part_histories" :key="index">
                                    {{ item.part.name ?? '-' }}
                                </div>
                            </template>
                            <template v-if="column.key === 'amount_list'">
                                <div v-for="(item, index) in record.part_histories" :key="index">
                                    {{ item.amount ?? '-' }}
                                </div>
                            </template>
                            <template v-if="column.key === 'claim_date'">
                                {{render_date(record.claim_date) }}
                            </template>
                            <template v-if="column.key === 'created_at'">
                                {{record.modelname === 'Part' ? render_date(record.claim_date) : render_date(record.withdrawed_at)}}
                            </template>
                            <template v-if="column.key === 'stock_refno_history'">
                                {{record.modelname === 'Part' ? '-': record.refno}}
                            </template>
                            <template v-if="column.key === 'barcode_history'">
                                {{record.barcode ?? '-'}}
                            </template>
                            <template v-if="column.key === 'part_name_history'">
                                {{record.modelname === 'Part' ? record.name: record.part_histories?.map(item => item.part.name).join(', ') || '-'}}
                            </template>
                            <template v-if="column.key === 'amount_history'">
                                {{record.modelname === 'Part' ? record.amount: record.part_histories?.map(item => item.amount).join(', ') || '-'}}
                            </template>
                            <template v-if="column.key === 'part_unit_history'">
                                <!-- {{record.modelname === 'Part' ? record.part_unit?.name: getUniquePartUnitNames(record)}} -->
                                <div v-if ="record.modelname === 'Part'">
                                    {{ record.part_unit?.name }}
                                </div>
                                <div v-else v-for="(name, index) in getUniquePartUnitNames(record)" :key="index">
                                    {{ name }}
                                </div>
                            </template>
                            <template v-if="column.key === 'stock_remark_history'">
                                {{record.remark}}
                            </template>
                            <template v-if="column.key === 'amount_remaining'">
                                {{Math.max((typeof record.amount === 'number' ? record.amount : 0) - (Array.isArray(record.part_histories) ? record.part_histories
                                            .filter(am => am.stock_history?.withdraw_status_id === 3 && am.stock_history?.is_deleted !== 1)
                                            .reduce((acc, item) =>acc + (typeof item.amount === 'number' ? item.amount : 0),0): 0),0)}}
                                </template>

                            <template v-if="column.key === 'id'">
                                <div>
                                    <a v-if="record.modelname=='StockHistory'" @click="go_show_modal_status(record, record.modelname)"><span style="font-size: 18px" class="material-symbols-outlined">trending_up</span></a>
                                    <a-divider v-if="record.modelname=='StockHistory'" type="vertical"></a-divider>
                                    <a @click="go_edit(record, record.modelname)"><span style="font-size: 18px" class="material-symbols-outlined">drive_file_rename_outline</span></a>
                                    <a-divider type="vertical"></a-divider>
                                    <a @click="go_remove(record.id, record.modelname)"><span style="font-size: 18px" class="material-symbols-outlined">delete</span></a>
                                </div>
                            </template>
                        </template>

                    </a-table>
                </a-row>
            </a-card>
        </div>
        <a-modal v-model:visible="show_modal" title="เลือกสถานะของการเบิก-จ่ายอะไหล่" ok-text="ตกลง" cancel-text="ปิด" @ok="save_status">
            <a-row type="flex" style="flex-direction: column">
                <a-form-item label="สถานะ" style="margin: 0;"/>
                <a-col flex="1 0">
                    <a-select style="width: 100%" v-model:value="selected_stock_status" placeholder="เลือกสถานะ"
                        :dropdownMatchSelectWidth="false">
                        <a-select-option v-for="{ id, name } in withdraw_status_list" :key="id" :value="id">{{
                                name
                        }}
                        </a-select-option>
                    </a-select>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
import VehicleService from '../../api/VehicleService'
import UserService from '../../api/UserService'
import Utility from '../../utility'
import SystemService from '../../api/SystemService'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import CompanyService from '../../api/CompanyService'
import XLSX from "xlsx-js-style";
import PartService from '../../api/PartService'
dayjs.extend(buddhistEra)
export default {
    name: 'autoparts',
    data() {
        return {
            editable: Utility.get_permission_editable_with_key('manage_car_parts'),
            company_list: [],
            business: false,
            logistics_a: false,
            part_unit_list: [],
            show_table_list: [],
            search_input: null,
            datetime: null,
            selected_type: null,
            selected_expire_type: null,
            show_modal: false,

            /*  update withdraw status*/
            withdraw_status_list: [],
            selected_stock_id: null,
            selected_stock_status: null,

            topic: {
                PartType: {
                    title: 'จัดการประเภทอะไหล่',
                    button_title: 'เพิ่มประเภทอะไหล่',
                    input: 'ประเภทอะไหล่',
                    clear: true,
                    columns: [
                        {
                            title: 'ชื่อประเภทอะไหล่',
                            dataIndex: 'name',
                            key: 'name',
                            sorter: true,
                            width: 670,
                            align: 'center',
                        }, {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 100,
                            align: 'center',
                            fixed: 'right'
                        }
                    ],
                },
                PartUnit: {
                    title: 'จัดการหน่วยอะไหล่',
                    button_title: 'เพิ่มหน่วยอะไหล่',
                    input: 'ชื่อหน่วยอะไหล่',
                    clear: true,
                    columns: [
                        {
                            title: 'ชื่อหน่วยอะไหล่',
                            dataIndex: 'name',
                            key: 'name',
                            sorter: true,
                            width: 670,
                            align: 'center',
                            check_duplicate: true,
                            check_rule: [
                                { 
                                    required: true, 
                                    validator: (rule, value) => this.validate_duplicate_conf(rule, value), 
                                    field: 'name',
                                    trigger: ['change', 'blur']
                                }
                            ]
                        }, {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 100,
                            align: 'center',
                            fixed: 'right'
                        }
                    ]
                },
                Vendor: {
                    title: 'จัดการผู้ขาย (Vendor)',
                    button_title: 'เพิ่มผู้ขาย (Vendor)',
                    input: 'ชื่อผู้ขาย (Vendor)',
                    clear: true,
                    columns: [
                        {
                            title: 'ชื่อผู้ขาย (Vendor)',
                            dataIndex: 'name',
                            key: 'name',
                            sorter: true,
                            width: 300,
                            align: 'center',
                        }, {
                            title: 'ชื่อผู้ติดต่อ',
                            dataIndex: 'contact_name',
                            key: 'contact_name',
                            width: 250,
                            align: 'center',
                        }, {
                            title: 'เบอร์มือถือ',
                            dataIndex: 'phone_no',
                            key: 'phone_no',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'เลขประจำตัวผู้เสียภาษี',
                            dataIndex: 'tax_id',
                            key: 'tax_id',
                            width: 150,
                            align: 'center',
                        },{
                            title: 'ที่อยู่',
                            dataIndex: 'address',
                            key: 'address',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 100,
                            align: 'center',
                            fixed: 'right'
                        }
                    ]
                },
                Technician: {
                    title: 'จัดการช่าง (Technician)',
                    button_title: 'เพิ่มช่าง (Technician)',
                    input: 'ชื่อช่าง (Technician)',
                    clear: true,
                    allow_import: false,
                    columns: [
                        {
                            title: 'ช่าง (Technician)',
                            dataIndex: 'fullname',
                            key: 'fullname',
                            sorter: true,
                            width: 400,
                            align: 'center',
                        }, {
                            title: 'ชื่อเล่น',
                            dataIndex: 'nickname',
                            key: 'nickname',
                            sorter: true,
                            width: 200,
                            align: 'center',
                        }, {
                            title: 'อีเมล',
                            dataIndex: 'email',
                            key: 'email',
                            width: 200,
                            align: 'center',
                        }, {
                            title: 'เบอร์มือถือ',
                            dataIndex: 'phone_no',
                            key: 'phone_no',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'เบอร์สำรอง',
                            dataIndex: 'phone_backup',
                            key: 'phone_backup',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'เลขประจำตัวผู้เสียภาษี	',
                            dataIndex: 'tax_id',
                            key: 'tax_id',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'ที่อยู่',
                            dataIndex: 'address',
                            key: 'address',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 100,
                            align: 'center',
                            fixed: 'right'
                        }
                    ]
                },
                Part: {
                    title: 'จัดการเบิกอะไหล่เข้า',
                    button_title: 'เพิ่มอะไหล่',
                    input: 'รหัส',
                    clear: true,
                    columns: [
                        {
                            title: 'รหัส',
                            dataIndex: 'barcode',
                            key: 'barcode',
                            sorter: true,
                            width: 300,
                            align: 'center',
                        }, {
                            title: 'ประเภท',
                            dataIndex: 'withdraw_type',
                            key: 'withdraw_type',
                            sorter: true,
                            width: 250,
                            align: 'center',
                        }, {
                            title: 'ประเภทอะไหล่',
                            dataIndex: 'part_type',
                            key: 'part_type',
                            sorter: true,
                            width: 250,
                            align: 'center',
                        }, {
                            title: 'ชื่ออะไหล่',
                            dataIndex: 'name',
                            key: 'name',
                            sorter: true,
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'จำนวน',
                            dataIndex: 'amount',
                            key: 'amount',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'จำนวนคงเหลือ',
                            dataIndex: 'amount_remaining',
                            key: 'amount_remaining',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'หน่วย',
                            dataIndex: 'part_unit',
                            key: 'part_unit',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'ราคา',
                            dataIndex: 'price',
                            key: 'price',
                            width: 150,
                            align: 'center',
                            customRender: ({ text }) => parseInt(text),
                        }, {
                            title: 'วันที่เบิกอะไหล่',
                            dataIndex: 'claim_date',
                            key: 'claim_date',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 100,
                            align: 'center',
                            fixed: 'right'
                        }
                    ]
                },
                StockHistory: {
                    title: 'รายการเบิก - จ่ายอะไหล่',
                    button_title: 'เพิ่ม - ลดอะไหล่',
                    input: 'รหัสอะไหล่',
                    select_stock: true,
                    select_status: true,
                    datepicker: true,
                    clear: true,
                    columns: [
                        {
                            title: 'เลขที่รายการ',
                            dataIndex: 'refno',
                            key: 'refno',
                            sorter: true,
                            align: 'center',
                        }, {
                            title: 'รหัสอะไหล่',
                            dataIndex: 'part_barcode',
                            key: 'part_barcode',
                            sorter: true,
                            width: 300,
                            align: 'center',
                        }, {
                            title: 'ประเภท',
                            dataIndex: 'withdraw_type',
                            key: 'withdraw_type',
                            sorter: true,
                            align: 'center',
                        }, {
                            title: 'ชื่ออะไหล่ที่เบิก',
                            dataIndex: 'part_list',
                            key: 'part_list',
                            align: 'center',
                        }, {
                            title: 'จำนวน',
                            dataIndex: 'amount_list',
                            key: 'amount_list',
                            align: 'center',
                        }, {
                            title: 'หน่วย',
                            dataIndex: 'part_unit_list',
                            key: 'part_unit_list',
                            align: 'center',
                        }, {
                            title: 'วันที่เบิก',
                            dataIndex: 'withdrawed_at',
                            key: 'withdrawed_at',
                            align: 'center',
                        }, {
                            title: 'สถานะ',
                            dataIndex: 'withdraw_status',
                            key: 'withdraw_status',
                            align: 'center',
                        }, {
                            title: 'ตัวเลือก',
                            dataIndex: 'id',
                            key: 'id',
                            width: 125,
                            align: 'center',
                            fixed: 'right',
                            align: 'center',
                        }
                    ]
                },
                PartHistoryLogisticsA: { //ไปดูหน้า repaire excel
                    title: 'ประวัติรายการเบิก - ถอนอะไหล่ (Stock Movement)',
                    input: 'ชื่ออะไหล่',
                    datepicker: true,
                    clear: true,
                    columns: [
                        {
                            title: 'วันที่',
                            dataIndex: 'created_at',
                            key: 'created_at',
                            width: 170,
                            sorter: true,
                            align: 'center',
                        }, {
                            title: 'ประเภท',
                            dataIndex: 'withdraw_type',
                            key: 'withdraw_type',
                            width: 250,
                            sorter: true,
                            align: 'center',
                        }, {
                            title: 'เลขที่รายการ',
                            dataIndex: 'stock_refno_history',
                            key: 'stock_refno_history',
                            width: 170,
                            align: 'center',
                        }, {
                            title: 'รหัส',
                            dataIndex: 'barcode_history',
                            key: 'barcode_history',
                            width: 170,
                            align: 'center',
                        }, {
                            title: 'ชื่ออะไหล่',
                            dataIndex: 'part_name_history',
                            key: 'part_name_history',
                            width: 250,
                            align: 'center',
                        }, {
                            title: 'จำนวน',
                            dataIndex: 'amount_history',
                            key: 'amount_history',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'หน่วย',
                            dataIndex: 'part_unit_history',
                            key: 'part_unit_history',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'หมายเหตุ',
                            dataIndex: 'stock_remark_history',
                            key: 'stock_remark_history',
                            width: 200,
                            align: 'center',
                        }
                    ]
                },
                PartHistory: {
                    title: 'ประวัติรายการเบิก - ถอนอะไหล่ (Stock Movement)',
                    input: 'ชื่ออะไหล่',
                    datepicker: true,
                    clear: true,
                    select_stock: true,
                    columns: [
                        {
                            title: 'วันที่',
                            dataIndex: 'stock_withdrawed_at',
                            key: 'stock_withdrawed_at',
                            width: 170,
                            sorter: true,
                            align: 'center',
                        }, {
                            title: 'เลขอะไหล่',
                            dataIndex: 'part_barcode',
                            key: 'part_barcode',
                            width: 250,
                            sorter: true,
                            align: 'center',
                        }, {
                            title: 'ชื่ออะไหล่',
                            dataIndex: 'part_name',
                            key: 'part_name',
                            width: 250,
                            align: 'center',
                        }, {
                            title: 'จำนวน',
                            dataIndex: 'amount',
                            key: 'amount',
                            width: 150,
                            align: 'center',
                        }, {
                            title: 'หมายเหตุ',
                            dataIndex: 'stock_remark',
                            key: 'stock_remark',
                            width: 200,
                            align: 'center',
                        }, {
                            title: 'Ref NO',
                            dataIndex: 'stock_refno',
                            key: 'stock_refno',
                            width: 170,
                            align: 'center',
                        }
                    ]
                }
            }
        }
    },
    computed: {
        render_type() {
            return this.$route.params.type
        }
    },
    methods: {
        render_date(date){
            return dayjs(date).format('DD-MM-YYYY')
        },
        clear_search(){
            this.search_input = null
            this.datetime = null
            this.selected_type = null
            this.selected_expire_type= null
        },
        getUniquePartUnitNames(record) {
            const ids = [...new Set(record.part_histories?.map(i => i.part_unit_id))];
            return ids.map(id => {
                const found = this.part_unit_list.find(u => u.id === id);
                return found?.name || '-';
            });
        },
        getColorWithDrawStatus(record) {
            let color;
            if(record.withdraw_status_id == 1) {
                color = 'yellow'
            }
            if(record.withdraw_status_id == 2) {
                color = 'orange'
            }
            if(record.withdraw_status_id == 3) {
                color = 'green'
            }
            if(record.withdraw_status_id == 4) {
                color = 'red'
            }
            return color
        },
        filtered_list(array) {
            let result = array
                .filter(({ withdrawed_at, stock_history, claim_date }) => {
                    if (this.datetime) {
                        const startDateUnix = dayjs(this.datetime[0]).startOf('day').valueOf();
                        const endDateUnix = dayjs(this.datetime[1]).endOf('day').valueOf();

                        if (withdrawed_at || claim_date) {
                            const targetDate = dayjs(withdrawed_at || claim_date);
                            const targetUnix = targetDate.valueOf();
                            return startDateUnix <= targetUnix && targetUnix <= endDateUnix;
                        }
                    } else {
                        return true;
                    }
                })
            .filter(({ withdraw_type_id })=>{
                if(this.selected_type){
                    return this.selected_type == withdraw_type_id
                }else{
                    return true
                }
            })
            .filter(({ withdraw_status_id })=>{
                if(this.selected_expire_type){
                    return this.selected_expire_type == withdraw_status_id
                }else{
                    return true
                }
            })
            .filter(({ name, firstname, lastname, refno, part, barcode, part_histories, part_barcode, part_list, stock_refno, part_name  }) => {
                if (this.search_input) {
                    const keyword = this.search_input.toLowerCase();
                    if (this.render_type === 'Part') {
                        return (
                            (barcode && barcode.toLowerCase().includes(keyword)) || 
                            (name && name.toLowerCase().includes(keyword))
                        );
                    } else if (this.render_type === 'StockHistory') {
                        const part = (part_histories && part_histories.length > 0) ? part_histories[0].part : null;
                        const partBarcode = part?.barcode?.toLowerCase() || '';
                        const partName = part?.name?.toLowerCase() || '';

                        return (
                            (refno && refno.toLowerCase().includes(keyword)) ||
                            (partBarcode.includes(keyword)) ||
                            (partName.includes(keyword)) ||
                            (part_barcode && part_barcode.toLowerCase().includes(keyword)) ||
                            (part_list && part_list.toLowerCase().includes(keyword))
                        );
                    } else if (this.render_type === 'PartHistory') {
                        return (
                           (refno && refno.toLowerCase().includes(keyword)) ||
                            (part_barcode && part_barcode.toLowerCase().includes(keyword)) ||
                            (part_name && part_name.toLowerCase().includes(keyword)) ||
                            (name && name.toLowerCase().includes(keyword)) ||
                            (barcode && barcode.toLowerCase().includes(keyword)) ||
                            (part_histories && part_histories.some(ph => ph.part?.name?.toLowerCase().includes(keyword)))
                        );
                    } else if (firstname && lastname) {
                        const fullName = `${firstname} ${lastname}`.toLowerCase();
                        return (
                            firstname.toLowerCase().includes(keyword) || 
                            lastname.toLowerCase().includes(keyword) ||
                            fullName.includes(keyword)
                        );
                    } else if (!this.logistics_a && refno) {
                        return refno.toLowerCase().includes(keyword);
                    } else if (part) {
                        return part?.name?.toLowerCase().includes(keyword);
                    } else if (barcode) {
                        return barcode.toLowerCase().includes(keyword);
                    }  else if (name) {
                        return name.toLowerCase().includes(keyword);
                    }
                } else {
                    return true;
                }
            })
             return result.sort((a, b) => {
                const dateA = new Date(a.withdrawed_at || a.claim_date || 0).getTime();
                const dateB = new Date(b.withdrawed_at || b.claim_date || 0).getTime();
                return dateB - dateA;
            });
        },
        async init_data_table(type) {
            let data = await SystemService.get_all(type)
            if (type === 'PartHistory') {
                data = []
                const dataPart = (await SystemService.get_all('Part')).map(item => ({ ...item, source: 'Part' }))
                const dataStockHistory = (await SystemService.get_all('StockHistory')).map(item => ({ ...item, source: 'StockHistory' }))
                data.push(...dataPart)
                data.push(...dataStockHistory)
            }
            this.show_table_list = data
        },
        button_on(type){
            this.$router.push(`/app/${type}/create`)
        },
        // async export_file () {
        //     await PartService.reportCompanyExpense()
        // },
        async export_file() {
            this.$message.loading({ content: "กำลังโหลด...", key: "loading" });
            const { data } = await PartService.reportCompanyExpense()

            var headersColumn;
            headersColumn = [
                { header: "วันที่", key: "create_at" },
                { header: "ประเภท", key: "withdraw_type" },
                { header: "เลขที่รายการ", key: "stock_refno" },
                { header: "รหัส", key: "barcode" },
                { header: "ชื่ออะไหล่", key: "part_name" },
                { header: "จำนวน", key: "amount" },
                { header: "หน่วย", key: "part_unit" },
                { header: "หมายเหตุ", key: "remark" },
            ];

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet(data, { header: headersColumn.map((h) => h.key) });
            XLSX.utils.sheet_add_aoa(workSheet, [headersColumn.map((h) => h.header)], { origin: "A1" });

            const margin = 5;
            const firstColumnWidth = 30;
            workSheet["!cols"] = headersColumn.map((header, index) => ({
                wch: index === 0 ? firstColumnWidth : header.header.length + margin,
            }));

            const range = XLSX.utils.decode_range(workSheet["!ref"]);
            const bgColor = "#d8d2e7"; 

            for (let R = range.s.r; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
                    let cell = workSheet[cellAddress];
                    if (!cell) {
                        cell = { v: "" }; // Add an empty cell if it doesn't exist
                        workSheet[cellAddress] = cell;
                    }

                    if (R === 0) {
                        cell.s = {
                            font: { bold: true },
                            fill: { fgColor: { rgb: bgColor.replace("#", "") } },
                            border: {
                                bottom: { style: "thin" },
                                right: { style: "thin" },
                                left: { style: "thin" },
                                top: { style: "thin" },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    } else {
                        cell.s = {
                            font: { bold: false },
                            border: {
                                bottom: { style: "thin" },
                                right: { style: "thin" },
                                left: { style: "thin" },
                                top: { style: "thin" },
                            },
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    }
                }
            }

            XLSX.utils.book_append_sheet(workBook, workSheet, "Report");
            XLSX.writeFile(workBook, "PartHistory.xlsx");
            this.$message.success({ content: "สร้างไฟล์สำเร็จ", key: "loading" });
        },
        async init_company_default() {
            this.company_list = await SystemService.get_all('CarCompany')
            const businessType = await CompanyService.getBusinessId(this.company_list[0].company_id)
            if ( businessType.data === 2){
                this.business = true
            }
            if ( businessType.data === 3){
                this.logistics_a = true
                this.topic.Part.columns[4].title = 'จำนวนเพิ่ม'
                this.topic.Part.columns[8].title = 'วันที่เพิ่มอะไหล่'
                this.topic.StockHistory.columns[6].title = 'วันที่เบิกจ่ายอะไหล่'
                this.topic.StockHistory.button_title = 'เบิกจ่ายอะไหล่'
                this.topic.StockHistory.input = 'รหัส'
            } else {
                delete this.topic.Part.columns[1]
                delete this.topic.Part.columns[5]
                delete this.topic.StockHistory.columns[3]
                delete this.topic.StockHistory.columns[4]
                delete this.topic.StockHistory.columns[5]
                this.topic.PartHistory.select_stock = false
            }
        },
        button_action(type) {
        },
        async go_remove(id, type) {
             if (type === 'Part') {
            const stockHistories = await SystemService.get_all('StockHistory');
            const isUsed = stockHistories.some(sh =>
                Array.isArray(sh.part_histories) &&
                sh.part_histories.some(ph => ph.part_id == id)
            );
            if (isUsed) {
                Swal.fire({
                    icon: 'warning',
                    title: 'ไม่สามารถลบรายการได้',
                    text: 'เนื่องจากมีรายการเบิกจ่ายค้างอยู่',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }
        }
            Swal.fire({
                title: `คุณต้องการลบข้อมูลนี้ใช่หรือไม่? [${type}ID: ${id}]`,
                text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้หากลบแล้ว!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่, ลบข้อมูลนี้!',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all(type, id)
                    this.init_data_table(type)
                    Swal.fire(
                        'ลบข้อมูลเรียบร้อย!',
                        'ข้อมูลของคุณถูกลบแล้ว',
                        'success'
                    )
                }
            })
        },
        go_edit(model_data, modelname) {
            var title_name = {
                PartType: 'name',
                PartUnit: 'name',
                Vendor: 'name',
                Technician: 'firstname',
                Part: 'name',
                StockHistory: 'refno',
            }
            this.$router.push(`/app/${modelname}/${model_data.id}?title_name_key=${title_name[modelname]}`)
        },
        go_show_modal_status(data, modelname){
            this.show_modal = true
            this.selected_stock_id = data.id
            this.selected_stock_status = data.withdraw_status_id
        },
        async save_status(){
            await SystemService.update_all('StockHistory',{data : {withdraw_status_id: this.selected_stock_status}}, this.selected_stock_id)
            this.selected_stock_status = null
            this.show_modal = false
            Swal.fire({
                title: 'บันทึกอะไหร่สำเร็จ',
                icon: 'success',
                timer: 1000,
                timerProgressBar: false,
                showConfirmButton: false,
            })
            this.init_data_table(this.render_type)
        },
        async get_default_data() {
            if(this.render_type == 'StockHistory' || this.render_type === 'PartHistory') {
                this.withdraw_status_list = await SystemService.get_all('WithdrawStatus')
                this.part_unit_list = await SystemService.get_all('PartUnit')
            }
        },
    },
    watch: {
        async render_type(newVal) {
            if (newVal) {
                this.clear_search();
                this.show_table_list = []
                await this.init_data_table(this.render_type)
                await this.get_default_data()
            }
        }
    },
    async mounted() {
        await this.init_company_default()
        this.init_data_table(this.render_type)
        await this.get_default_data()
    }
}
</script>

<style>
.ant-modal-footer{
    display: flex;
    justify-content: flex-end;
}
.ant-table-thead .center-header {
  text-align: center; /* จัดตำแหน่งหัวคอลัมน์ให้อยู่ตรงกลาง */
}
</style>